// ═══════════════════════════════════════════════════════════════
// Sensando Design System — Vuetify 3 Component Defaults
// Tactical Dark Theme • Military-Grade C2 Interface
// ═══════════════════════════════════════════════════════════════

export default {
  // ─── Global ───
  global: {
    ripple: false, // Tactical UIs feel snappier without ripple
  },

  IconBtn: {
    icon: true,
    color: 'default',
    variant: 'text',
    VIcon: {
      size: 24,
    },
  },
  VAlert: {
    VBtn: {
      color: undefined,
    },
  },
  VAvatar: {
    variant: 'flat',
    VIcon: {
      size: 24,
    },
  },

  // ─── Badges ───
  VBadge: {
    dot: true,
    color: 'success',
  },

  // ─── Buttons ───
  VBtn: {
    color: 'primary',
    variant: 'flat',
    rounded: 'lg',
    density: 'comfortable',
    style: 'text-transform: none; font-weight: 600; font-size: 12px; letter-spacing: 0.03em;',
  },

  // ─── Cards ───
  VCard: {
    rounded: 'lg',
    elevation: 0,
    border: true,
    color: 'surface',
  },

  // ─── Chips ───
  VChip: {
    elevation: 0,
    size: 'small',
    rounded: 'pill',
    variant: 'tonal',
    style: 'font-size: 10px; font-weight: 600;',
  },

  VList: {
    activeColor: 'primary',
  },
  VPagination: {
    activeColor: 'primary',
  },

  // ─── Tabs ───
  VTabs: {
    color: 'primary',
    density: 'compact',
    sliderColor: 'primary',
    bgColor: 'transparent',
    VSlideGroup: {
      showArrows: true,
    },
  },
  VTab: {
    style: 'text-transform: none; font-size: 11px; font-weight: 600; letter-spacing: 0.03em; min-width: 60px;',
  },

  // ─── Navigation Drawer (Sidebar) ───
  VNavigationDrawer: {
    color: '#0D1117',
    width: 240,
    border: 0,
  },

  // ─── App Bar (TopBar) ───
  VAppBar: {
    color: '#111827',
    density: 'compact',
    height: 48,
    elevation: 0,
    border: true,
  },

  // ─── Data Tables ───
  VDataTable: {
    density: 'compact',
    fixedHeader: true,
    hover: true,
    style: "font-family: 'JetBrains Mono', monospace; font-size: 10px;",
    itemsPerPage: 50,
  },

  // ─── Dialogs (Modals) ───
  VDialog: {
    maxWidth: 420,
    scrim: 'black',
  },

  // ─── Tooltips ───
  VTooltip: {
    location: 'top',
    contentClass: 'sensando-tooltip',
  },

  VCheckboxBtn: {
    color: 'primary',
    hideDetails: 'auto',
  },
  VCheckbox: {
    color: 'primary',
    hideDetails: 'auto',
  },
  VRadioGroup: {
    color: 'primary',
    hideDetails: 'auto',
  },
  VRadio: {
    color: 'primary',
    hideDetails: 'auto',
  },

  // ─── Inputs ───
  VSelect: {
    variant: 'outlined',
    density: 'compact',
    rounded: 'lg',
    color: 'primary',
    bgColor: '#0F172A',
    hideDetails: 'auto',
    style: 'font-size: 12px;',
  },
  VRangeSlider: {
    color: 'primary',
    density: 'comfortable',
    thumbLabel: true,
    hideDetails: 'auto',
  },
  VRating: {
    color: 'rgba(var(--v-theme-on-background),0.23)',
    activeColor: 'warning',
  },
  VProgressCircular: {
    color: 'primary',
  },
  VSlider: {
    color: 'primary',
    hideDetails: 'auto',
  },
  VTextField: {
    variant: 'outlined',
    density: 'compact',
    rounded: 'lg',
    color: 'primary',
    bgColor: '#0F172A',
    hideDetails: 'auto',
    style: 'font-size: 12px;',
  },
  VAutocomplete: {
    variant: 'outlined',
    density: 'compact',
    rounded: 'lg',
    color: 'primary',
    bgColor: '#0F172A',
    hideDetails: 'auto',
    style: 'font-size: 12px;',
  },
  VCombobox: {
    variant: 'outlined',
    density: 'compact',
    rounded: 'lg',
    color: 'primary',
    bgColor: '#0F172A',
    hideDetails: 'auto',
    style: 'font-size: 12px;',
  },
  VFileInput: {
    variant: 'outlined',
    density: 'compact',
    rounded: 'lg',
    color: 'primary',
    hideDetails: 'auto',
    style: 'font-size: 12px;',
  },
  VTextarea: {
    variant: 'outlined',
    density: 'compact',
    rounded: 'lg',
    color: 'primary',
    bgColor: '#0F172A',
    hideDetails: 'auto',
    style: 'font-size: 12px;',
  },
  VSwitch: {
    color: 'primary',
    hideDetails: 'auto',
  },
}
